import { makeStyles } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import ToleranceQualityCheck from '../QualityCheckTypes/ToleranceQualityCheck';
import YesNoQualityCheck from '../QualityCheckTypes/YesNoQualityCheck';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import { dataService } from '../../../Services/data.service';
import { toast } from 'react-toastify';
import { bool, decimal, QualityOutOfSpec, uomMm, uomKg, UnKnownQualityCheckType, dimensionQualityChecks, qualityChecks, qualitySampleResults } from '../../../Config/constants';
import AlertDialog from '../../Shared/Dialogs/AlertDialog';
import { CalculateToleranceFactor } from '../../../Helpers/QualitySampleHelper';
import { systemMessageIds } from '../../../Config/constants';
import { scissorStates, scissorTypes } from '../../../Config/scissorStates';
import { connect } from 'react-redux';
import ExtraReasonDialog from './ExtraReasonDialog';

export const QualityCheckForm = (props) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const [sequence, setSequence] = useState(0);
    const [fieldsEmptyDialogOpen, setFieldsEmptyDialogOpen] = useState(false);
    const [dialogTitle, setDialogTitle] = useState(null);
    const [dialogContext, setDialogContext] = useState(null);
    const [toleranceFactor, setToleranceFactor] = useState(null);
    const [plateLength, setPlateLength] = useState(null);
    const [plateWidth, setPlateWidth] = useState(null);
    const [calculatedWeight, setCalculatedWeight] = useState(null);
    const [measuredWeight, setMeasuredWeight] = useState(null);
    const [lengteUom, setLengteUom] = useState(null);
    const [breedteUom, setBreedteUom] = useState(null);
    const [resultSend, setResultSend] = useState(false)
    const [criticalList, setCriticalList] = useState(null)
    const [reasonDialogOpen, setReasonDialogOpen] = useState(false);
    const [reasonMistakes, setReasonMistakes] = useState([]);
    const [multiplicationFactor, setMultiplicationFactor] = useState(0);
    const [criticalSample, setCriticalSample] = useState(0);
    const [output, setOutput] = useState(null)

    let history = useHistory();

    useEffect(() => {
        if (props.qualityChecks) {
            let samples = props.qualityChecks.qualitySamples[0].samples
            if (props.qualityChecks.qualitySamples.length !== 1) {
                samples = props.qualityChecks.qualitySamples[props.qualityChecks.qualitySamples.length - 1].samples
            }
            var i;
            for (i = 0; i < samples.length; i++) {
                if (samples[i].dataTypeId !== bool && samples[i].dataTypeId !== decimal) {
                    // let message = t("Unknown quality check (") + samples[i].code + t(") type for pallet ") + props.palletNumber + t(", on line ") + props.productionOrder.machineCode
                    dataService.saveNotification(UnKnownQualityCheckType, props.palletNumber, props.workstation.selectedWorkstation, "", 0, props.productionOrder.reference, samples[i].id, samples[i].code, systemMessageIds.UnknownQualityCheck, "").then().catch((error) => { toast.error(error, { position: "top-center" }) })
                }
            }
            if (props.qualityChecks.qualitySamples.length !== sequence + 1) {
                setSequence(props.qualityChecks.qualitySamples.length - 1)
            }

            setToleranceFactor(CalculateToleranceFactor(props.qualityChecks.qualitySamples[props.qualityChecks.qualitySamples.length - 1].samples.filter(x => x.dataTypeId === decimal && x.toleranceErrorMin !== null)))

            if (criticalList == null) {
                dataService.GetIsBookingCritical(props.productionOrder.id).then(list => {
                    setCriticalList(list)
                }).catch((error) => { toast.error(error, { position: "top-center" }) })
            }
        }
        // eslint-disable-next-line
    }, [props.qualityChecks, sequence, props.productionOrder, props.workstation.selectedWorkstation, props.palletNumber])

    useEffect(() => {
        dataService.getMachineByCode(props.productionOrder.machineCode).then(machine => {
            if (machine.metaData) {
                let machineMetaData = JSON.parse(machine.metaData)
                setMultiplicationFactor(machineMetaData[0].MetaData[0].Factor)
            }
        }).catch((error) => { toast.error(error, { position: "top-center" }) })
    }, [])


    const qualityCheckChanged = (event, code) => {
        var tempQualityChecks = JSON.parse(JSON.stringify(props.qualityChecks));
        if (tempQualityChecks.qualitySamples[sequence].samples.some(x => x.code === code)) {
            var changedSample = tempQualityChecks.qualitySamples[sequence].samples.find(x => x.code === code);
            if (changedSample.dataTypeId === decimal) {
                if (event.target.value === "") {
                    changedSample.sampleValue = "0";
                } else {
                    changedSample.sampleValue = event.target.value;
                }
            } else if (changedSample.dataTypeId === bool) {
                if (event.target.value === 'true') {
                    changedSample.result = qualitySampleResults.OK;
                }
                else {
                    changedSample.result = qualitySampleResults.ERROR;
                }
            }
            if (changedSample.description.includes("Lengte")) {
                setPlateLength(event.target.value);
            }
            if (changedSample.description.includes(dimensionQualityChecks.BREEDTE)) {
                setPlateWidth(event.target.value);
            }

            if (changedSample.description.includes(qualityChecks.OUTPUT_EXTRUDEUR) || changedSample.description.includes(qualityChecks.OUTPUT_EXTRUDER)) {
                setOutput(event.target.value);
            }

            if (changedSample.description.includes(dimensionQualityChecks.GEWICHT) || changedSample.description.includes(qualityChecks.TIRAGE)) {
                //We add the necessary data to the function because there was always a delay on the props.qualityChecks data that was read in the calculateOutput function...
                //Bug: IPB-666
                calculateOutput((changedSample.description.includes(dimensionQualityChecks.GEWICHT) ? parseFloat(event.target.value) : null), (changedSample.description.includes(qualityChecks.TIRAGE) ? parseFloat(event.target.value) : null), tempQualityChecks, sequence);
            } else {
                //the props.qualityChecks will be set in the calculateOutput function, that's why this one is in the else-statement
                props.setQualityChecks(tempQualityChecks);

            }
        }
    }

    const calculateOutput = (weightData, tirageData, tempQualityChecks, changedSequence) => {
        let tempOutput = 0;

        const weightSample = props.qualityChecks.qualitySamples[changedSequence].samples.find(sample => sample.description.includes(dimensionQualityChecks.GEWICHT));
        const tirageSample = props.qualityChecks.qualitySamples[changedSequence].samples.find(sample => sample.description.includes(qualityChecks.TIRAGE));

        if (!weightSample && !tirageSample) {
            return; // Exit if neither sample exists
        }

        let weight = null;
        let tirage = null;

        if (weightData !== null) {
            weight = weightData / 1000;
        } else if (weightSample?.sampleValue) {
            weight = parseFloat(weightSample.sampleValue) / 1000;
        }

        if (tirageData !== null) {
            tirage = tirageData;
        } else if (tirageSample?.sampleValue) {
            tirage = parseFloat(tirageSample.sampleValue);
        }

        let outputSample = tempQualityChecks.qualitySamples[changedSequence].samples.find(x =>
            x.description.includes(qualityChecks.OUTPUT_EXTRUDEUR) ||
            x.description.includes(qualityChecks.OUTPUT_EXTRUDER)
        );

        if (weight !== null && tirage !== null) {
            tempOutput = Math.round(tirage * multiplicationFactor * weight);
            if (outputSample) {
                outputSample.sampleValue = tempOutput.toString();
            }
            setOutput(tempOutput);
        } else {
            // If only one of the values exists, still set its corresponding value
            if (weight !== null && weightSample) {
                weightSample.sampleValue = (weight * 1000).toString(); // Convert back to original scale if necessary
            }
            if (tirage !== null && tirageSample) {
                tirageSample.sampleValue = tirage.toString();
            }
        }

        props.setQualityChecks(tempQualityChecks);
    }

    const saveQualityChecks = () => {
        if (checkForEmptyValues()) {
            setDialogTitle(t("Empty fields"));
            setDialogContext(t("Please fill in the required fields"));
            setFieldsEmptyDialogOpen(true);
        } else {
            var tempQualityChecks = JSON.parse(JSON.stringify(props.qualityChecks));

            dataService.GetCheckNumberForPallet(props.palletNumber).then(seq => {

                var thisQualitycheck = tempQualityChecks.qualitySamples[sequence];

                setResultSend(true);

                thisQualitycheck.carrierInfo.sampleSequence = seq
                if (props.workstationState.workstationsWithScissorStatusInfo.find(x => x.id === parseInt(props.productionOrder.machineId)) && props.workstationState.workstationsWithScissorStatusInfo.find(x => x.id === parseInt(props.productionOrder.machineId)).scissorStatuses.find(x => x.scissorName === scissorTypes.UPPER)) {
                    thisQualitycheck.machineData = {
                        Id: parseInt(props.productionOrder.machineId),
                        LineSpeed: props.machineParameter.speed.find(x => x.lineNumber === parseInt(props.productionOrder.machineCode)) ? props.machineParameter.speed.find(x => x.lineNumber === parseInt(props.productionOrder.machineCode)).speed : 0,
                        PumpRPMSpeed: props.machineParameter.rpmPump.find(x => x.lineNumber === parseInt(props.productionOrder.machineCode)) ? props.machineParameter.rpmPump.find(x => x.lineNumber === parseInt(props.productionOrder.machineCode)).rpmPump : 0,
                        UpperScissorInScrap: props.workstationState.workstationsWithScissorStatusInfo.find(x => x.id === parseInt(props.productionOrder.machineId)).scissorStatuses.find(x => x.scissorName === scissorTypes.UPPER).name === scissorStates.SCRAP,
                        LowerScissorInScrap: props.workstationState.workstationsWithScissorStatusInfo.find(x => x.id === parseInt(props.productionOrder.machineId)).scissorStatuses.find(x => x.scissorName === scissorTypes.LOWER).name === scissorStates.SCRAP
                    }
                }

                thisQualitycheck.carrierInfo.producedOnMachineId = parseInt(props.machineId);
                validateForNotification(seq, props.qualityChecks);

                let isCritical = false;
                let criticalSample = 0;
                let mistakes = [];

                if (criticalList !== null && criticalList !== undefined) {
                    criticalList.map(c => {
                        let currentsample = thisQualitycheck.samples.find(s => s.code === c.code);
                        if (currentsample.sampleValue !== null && currentsample.sampleValue !== undefined && currentsample.sampleValue !== "") {
                            if (currentsample.toleranceErrorMax === null) {
                                if (currentsample.qualitySampleResults.OK === qualitySampleResults.OK) {
                                    isCritical = true;
                                    criticalSample = currentsample.id;
                                    mistakes.push(c.description);
                                }
                            } else if (currentsample.toleranceWarningMax === null) {
                                if (parseFloat(currentsample.sampleValue) > (currentsample.expectedValue + currentsample.toleranceErrorMax) || parseFloat(currentsample.sampleValue) < (currentsample.expectedValue - currentsample.toleranceErrorMin)) {
                                    isCritical = true;
                                    criticalSample = currentsample.id;
                                    mistakes.push(c.description);
                                }
                            } else {
                                if (parseFloat(currentsample.sampleValue) > (currentsample.expectedValue + currentsample.toleranceWarningMax) || parseFloat(currentsample.sampleValue) < (currentsample.expectedValue - currentsample.toleranceWarningMin)) {
                                    isCritical = true;
                                    criticalSample = currentsample.id;
                                    mistakes.push(c.description);
                                }
                            }
                        }
                    })

                    setCriticalSample(criticalSample);
                }

                if (isCritical) {
                    setReasonDialogOpen(true);
                    setReasonMistakes(mistakes);
                } else {
                    saveSamples(false, "");
                }


            }).catch((error) => { toast.error(error, { position: "top-center" }) })

        }

    }

    const validateForNotification = (seq, qualityChecks) => {
        let qualitySamplesNotOK = [];
        var i;
        for (i = 0; i < qualityChecks.qualitySamples[sequence].samples.length; i++) {
            let sample = qualityChecks.qualitySamples[sequence].samples[i];

            if (sample.result === qualitySampleResults.ERROR && sample.dataTypeId === bool) {
                qualitySamplesNotOK.push(sample);
            }

            if (sample.dataTypeId === decimal) {
                if (sample.toleranceMax !== null && sample.toleranceMin !== null) {
                    if (parseFloat(sample.sampleValue) - sample.toleranceMax > sample.expectedValue || parseFloat(sample.sampleValue) + sample.toleranceMin < sample.expectedValue) {
                        qualitySamplesNotOK.push(sample);
                    }
                }
            }
        }

        if (qualitySamplesNotOK.length > 0) {
            dataService.saveNotification(QualityOutOfSpec, props.palletNumber, props.workstation.selectedWorkstation, props.productionOrder.machineCode, seq, props.productionOrder.reference, 0, "", systemMessageIds.QualityOutOfSpec, "").then().catch((error) => { toast.error(error, { position: "top-center" }) })
            dataService.saveOPCNotification(props.productionOrder.bomOut[0].productName, props.palletNumber, props.productionOrder.machineCode, seq, props.productionOrder.reference).then().catch((error) => { toast.error(error, { position: "top-center" }) })
        }
    }

    const saveSamples = (isCritical, criticalreason) => {
        var qualityChecks = JSON.parse(JSON.stringify(props.qualityChecks));
        var qualitySamples = qualityChecks.qualitySamples[sequence];
        qualityChecks.qualitySamples = [];

        if (qualitySamples.samples.some(x => x.description.includes(dimensionQualityChecks.GEWICHT))) {
            let qualityWeightCheck = qualitySamples.samples.find(x => x.description.includes(dimensionQualityChecks.GEWICHT));
            if (qualityWeightCheck !== null) {
                if (qualityWeightCheck.uom.toLowerCase().includes(uomKg.toLowerCase()) || qualityWeightCheck.uom.toLowerCase() == uomKg.toLowerCase()) {
                    qualityWeightCheck.sampleValue = String(parseFloat(qualityWeightCheck.sampleValue) / 1000);
                }
            }
        }

        qualityChecks.qualitySamples.push(qualitySamples);

        dataService.saveQualitySamples(qualityChecks, props.productionOrder.id, props.productionOrder.machineCode, isCritical, criticalreason, criticalSample).then(() => {
            setTimeout(() => { history.push('/sampling/' + props.productionOrder.id + '/' + props.palletNumber + "/" + props.progress + "/1/" + props.machineId + "/detail/" + props.productionOrder.orderLineId) }, 1000);
        }).catch((error) => { toast.error(error, { position: "top-center" }) });
        setCriticalList(null);
    }

    const enterExtraReason = (reason) => {
        if (reason !== null && reason !== undefined && reason !== "") {
            setReasonDialogOpen(false);
            saveSamples(true, reason);
        } else {
            toast.error(t("EnterValidReason"), { position: "top-center" });
        }
    }

    const checkForEmptyValues = () => {
        var qualityChecks = JSON.parse(JSON.stringify(props.qualityChecks));
        var valueChecks = qualityChecks.qualitySamples[sequence].samples.filter(x => x.dataTypeId === decimal);

        if (valueChecks.some(x => x.sampleValue === null || x.sampleValue === 0)) {
            return true;
        } else {
            return false;
        }
    }

    const calculateWeightPerSquareM = () => {
        if (plateLength > 0 && plateWidth > 0) {

            let lengteFactor = 1;
            let breedteFactor = 1;
            if (lengteUom === uomMm) {
                lengteFactor = 0.001;
            }
            if (breedteUom === uomMm) {
                breedteFactor = 0.001;
            }

            let totalFactor = lengteFactor * breedteFactor;

            setCalculatedWeight(measuredWeight * 1000 / (plateLength * plateWidth * totalFactor));
            let tempQualityChecks = Object.assign({}, props.qualityChecks);
            tempQualityChecks.qualitySamples[sequence].samples.filter(x => x.dataTypeId === decimal).find(x => x.description.includes("Gewicht")).sampleValue = String(measuredWeight * 1000 / (plateLength * plateWidth * totalFactor));
            props.setQualityChecks(tempQualityChecks);
        }
    }

    const measuredWeightChanged = (weight) => {
        setMeasuredWeight(weight);
    }

    return (
        <div className={classes.background}>
            <div className={classes.spacer}>
            </div>
            <div className={classes.toleranceTitle}>
                {props.qualityChecks.qualitySamples[sequence].samples.some(x => x.dataTypeId === decimal) && t("Tolerance")}
            </div>
            {props.qualityChecks ? props.qualityChecks.qualitySamples[sequence].samples.sort((a, b) => new Date(b.dataTypeId) - new Date(a.dataTypeId)).map((x, qcIndex) => {
                if (x.dataTypeId === decimal) {

                    return (
                        toleranceFactor &&
                        <ToleranceQualityCheck key={"qcIndex_" + qcIndex} {...props} setLengteUom={setLengteUom} setBreedteUom={setBreedteUom} lengteUom={lengteUom} breedteUom={breedteUom} measuredWeightChanged={measuredWeightChanged} calculateWeightPerSquareM={calculateWeightPerSquareM} measuredWeight={measuredWeight} calculatedWeight={calculatedWeight} output={output} setPlateLength={setPlateLength} setPlateWidth={setPlateWidth} plateWidth={plateWidth} plateLength={plateLength} toleranceFactor={toleranceFactor} qualityCheck={x} qualityCheckChanged={qualityCheckChanged}></ToleranceQualityCheck>
                    )
                }
                else if (x.dataTypeId === bool) {
                    return (
                        <YesNoQualityCheck key={"qcIndex_" + qcIndex} qualityCheck={x} qualityCheckChanged={qualityCheckChanged} ></YesNoQualityCheck>
                    )
                }

                return <React.Fragment key={"qcIndex_" + qcIndex} ></React.Fragment>
            }
            ) : <React.Fragment></React.Fragment>}
            <button className={classes.nextButton} disabled={resultSend} style={{ opacity: resultSend ? "0.5" : "1" }} onClick={() => saveQualityChecks()}>{t("SAVE")}</button>
            <AlertDialog dialogOpen={fieldsEmptyDialogOpen} dialogTitle={dialogTitle} dialogContext={dialogContext} closeDialog={() => setFieldsEmptyDialogOpen(false)} action={() => setFieldsEmptyDialogOpen(false)}></AlertDialog>
            <ExtraReasonDialog dialogOpen={reasonDialogOpen} reasonMistakes={reasonMistakes} enterExtraReason={enterExtraReason}></ExtraReasonDialog>
        </div>
    )
}

const useStyles = makeStyles({
    background: {
        width: "calc(100% - 150px)",
        float: "left",
        padding: "40px",
        boxSizing: "border-box",
        height: "100%",
        position: "relative",
        top: "90px",
        left: "150px",
    },
    qualityCheckTextField: {
        backgroundColor: "white",
        width: "35%"
    },
    qualityCheckName: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        color: "#020100",
    },
    qualityCheckContainer: {
        width: "100%",
        float: "left",
        height: "80px",
        boxSizing: "border-box"
    },
    toleranceContainer: {
        width: "40%",
        float: "left",
        height: "80px",
        boxSizing: "border-box",
        paddingTop: "30px"
    },
    qualityCheck: {
        width: "100%",
        height: "80px"
    },
    toleranceTitle: {
        textAlign: "center",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        width: "35%",
        float: "left",
        height: "20px",
        position: "relative",
        right: "10px"
    },
    spacer: {
        width: "35%",
        float: "left",
        height: "20px"
    },
    nextButton: {
        width: "120px",
        border: "none",
        cursor: 'pointer',
        outline: "none",
        backgroundColor: FlagstoneTheme.palette.primary.main,
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "white",
        borderRadius: "5px",
        height: "40px",
        marginBottom: "60px",
        marginTop: "30px"
    },

});

function mapStateToProps(state) {
    return {
        machineParameter: state.machineParameter,
        workstationState: state.workstationState,
    }
}

export default connect(mapStateToProps)(QualityCheckForm)